import { useCallback, useContext } from 'react';
import styled from '@emotion/styled';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { WorkspaceFileSummaryContext } from '@/containers/Workspace.File.Preview/Context';

export function SummaryActionDownload() {
  const ctx = useContext(WorkspaceFileSummaryContext);
  const { palette, enabled } = useContext(AppThemingContext);

  const primaryColor = enabled && palette?.primary
    ? palette.primary.main
    : 'var(--pri-02)';

  const handleDownload = useCallback(() => {
    ctx.download();
  }, [ctx]);

  return (
    <StyledButton
      primaryColor={primaryColor}
      onClick={handleDownload}>
      Export
    </StyledButton>
  );
}

type StyledButtonProps = {
  primaryColor: string;
};

const StyledButton = styled('button') <StyledButtonProps>`
  font-family: var(--font-bold);
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  min-width: 100px;
  padding: 10px;
  border-radius: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background-color 180ms ease-in-out,
    border 120ms ease-in,
    border-color 120ms ease-in,
    color 120ms ease-in;
  
  color: ${props => props.primaryColor};
  border: 2px solid ${props => props.primaryColor};
  background-color: transparent;
  
  &:hover {
    background-color: ${props => props.primaryColor}10;
  }
  
  &:disabled {
    border-color: var(--gray-l);
    color: var(--gray-l);
    cursor: not-allowed;
  }
`;